import React from "react";
import { Typography } from "antd";
import {
  AppstoreOutlined,
  UnorderedListOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { WA } from "../../theme";
import TextoWhatsapp from "../Chat/TextoWhatsapp";

const { Text } = Typography;

export const TIPOS_INTERACTIVO = [
  { value: "buttons", label: "Botones de respuesta", icon: <AppstoreOutlined /> },
  { value: "list", label: "Lista de opciones", icon: <UnorderedListOutlined /> },
  { value: "cta_url", label: "Botón con enlace (CTA URL)", icon: <LinkOutlined /> },
];

export const etiquetaTipo = (tipo) =>
  TIPOS_INTERACTIVO.find((t) => t.value === tipo)?.label || tipo;

export const payloadVacio = (tipo) => {
  const base = { header: { text: "" }, body: { text: "" }, footer: { text: "" } };
  if (tipo === "buttons") return { ...base, buttons: [{ title: "" }] };
  if (tipo === "list") {
    return { ...base, button: "Ver opciones", sections: [{ title: "", rows: [{ title: "", description: "" }] }] };
  }
  if (tipo === "cta_url") return { ...base, display_text: "", url: "" };
  return base;
};

export const asignarIds = (tipo, payload) => {
  if (tipo === "buttons") {
    return {
      ...payload,
      buttons: (payload.buttons || []).map((b, i) => ({ id: b.id || `btn_${i}`, title: b.title })),
    };
  }
  if (tipo === "list") {
    let n = 0;
    return {
      ...payload,
      sections: (payload.sections || []).map((s) => ({
        ...s,
        rows: (s.rows || []).map((r) => ({
          id: r.id || `row_${n++}`,
          title: r.title,
          ...(r.description ? { description: r.description } : {}),
        })),
      })),
    };
  }
  return payload;
};

export const limpiarPayload = (payload) => {
  const out = { ...payload };
  if (!out.header?.text?.trim()) delete out.header;
  if (!out.footer?.text?.trim()) delete out.footer;
  return out;
};

export const PreviewInteractivo = ({ tipo, payload = {} }) => {
  const chip = {
    display: "block",
    marginTop: 6,
    padding: "6px 10px",
    background: WA.surface,
    border: `1px solid ${WA.border}`,
    borderRadius: 6,
    textAlign: "center",
    color: WA.textPrimary,
    fontWeight: 600,
    fontSize: 13,
  };

  return (
    <div>
      {payload.header?.text && (
        <div style={{ fontWeight: 700, marginBottom: 2 }}>
          <TextoWhatsapp texto={payload.header.text} />
        </div>
      )}
      {payload.body?.text && (
        <div>
          <TextoWhatsapp texto={payload.body.text} />
        </div>
      )}
      {payload.footer?.text && (
        <Text type="secondary" style={{ fontSize: 11, display: "block", marginTop: 2 }}>
          {payload.footer.text}
        </Text>
      )}

      {tipo === "buttons" &&
        (payload.buttons || []).map((b, i) => (
          <span key={b.id || i} style={chip}>
            {b.title}
          </span>
        ))}

      {tipo === "list" && (
        <>
          <span style={chip}>{payload.button || "Ver opciones"}</span>
          {(payload.sections || []).map((s, si) => (
            <div key={si} style={{ marginTop: 6 }}>
              {s.title && <Text type="secondary" style={{ fontSize: 11 }}>{s.title}</Text>}
              {(s.rows || []).map((r, ri) => (
                <div key={r.id || ri} style={{ fontSize: 13, paddingLeft: 6 }}>
                  • {r.title}
                  {r.description && (
                    <Text type="secondary" style={{ fontSize: 11 }}> — {r.description}</Text>
                  )}
                </div>
              ))}
            </div>
          ))}
        </>
      )}

      {tipo === "cta_url" && (
        <a href={payload.url} target="_blank" rel="noreferrer" style={chip}>
          <LinkOutlined /> {payload.display_text || "Abrir enlace"}
        </a>
      )}
    </div>
  );
};
